import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";
import appStoreBadge from "@/assets/app-store-badge.png";
import googlePlayBadge from "@/assets/google-play-badge.png";

const AppStoreBadges = () => {
  const { t, localePath } = useLanguage();
  const comingSoon = t({ ar: "قريبًا", en: "Coming soon" });
  const href = localePath("/seller-app");

  const badgeOverlay = (
    <span className="absolute -top-1.5 ltr:-right-1.5 rtl:-left-1.5 bg-primary text-primary-foreground text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wide shadow-sm">
      {comingSoon}
    </span>
  );

  return (
    <div className="flex flex-col items-center md:items-start gap-2">
      <p className="text-xs text-current">
        {t({ ar: "حمّل تطبيق البائع ببلاش", en: "Download the Seller App for free" })}
      </p>
      <div className="flex items-center gap-3">
        <Link to={href} aria-label={t({ ar: "تطبيق بائعي رنين — قريبًا على App Store", en: "raneen Seller App — coming soon on the App Store" })} className="relative hover:opacity-90 transition-opacity">
          {badgeOverlay}
          <img src={appStoreBadge} alt="Download on the App Store" width={120} height={40} loading="lazy" decoding="async" className="h-10" />
        </Link>
        <Link to={href} aria-label={t({ ar: "تطبيق بائعي رنين — قريبًا على Google Play", en: "raneen Seller App — coming soon on Google Play" })} className="relative hover:opacity-90 transition-opacity">
          {badgeOverlay}
          <img src={googlePlayBadge} alt="Get it on Google Play" width={135} height={40} loading="lazy" decoding="async" className="h-10" />
        </Link>
      </div>
    </div>
  );
};

export default AppStoreBadges;
